import { cn } from '@/lib/utils';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';

interface PdfViewerProps {
  visibleTab: boolean;
  src: string;
  generatePdf: () => void;
  generatingPdf: boolean;
}

export const PdfViewer = ({ visibleTab, src, generatePdf, generatingPdf }: PdfViewerProps) => {
  return (
    <div className={cn('h-full mb-12', visibleTab ? 'block' : 'hidden')}>
      <IfPermitted permissions={[UserPermissions.PDF_REPORT_REGENERATION]} fallback={null}>
        <div className={cn('text-sm text-gray-500 mb-2 text-right')}>
          <button
            onClick={generatePdf}
            disabled={generatingPdf}
            className={cn('text-gray-600 underline hover:text-gray-800 focus:outline-none')}
          >
            Click here
          </button>{' '}
          to regenerate the report.
        </div>
      </IfPermitted>
      <iframe src={src} width="100%" height="100%" title="Farm Report" />
    </div>
  );
};
